import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../wayfinder'
import qr from './qr'
import session from './session'
import avatar from './avatar'
import onlineTopup from './online-topup'
/**
* @see \App\Http\Controllers\Api\V1\MiniAppAuthController::auth
* @see app/Http/Controllers/Api/V1/MiniAppAuthController.php:23
* @route '/api/v1/mini-app/auth'
*/
export const auth = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: auth.url(options),
    method: 'post',
})

auth.definition = {
    methods: ["post"],
    url: '/api/v1/mini-app/auth',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\V1\MiniAppAuthController::auth
* @see app/Http/Controllers/Api/V1/MiniAppAuthController.php:23
* @route '/api/v1/mini-app/auth'
*/
auth.url = (options?: RouteQueryOptions) => {
    return auth.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\V1\MiniAppAuthController::auth
* @see app/Http/Controllers/Api/V1/MiniAppAuthController.php:23
* @route '/api/v1/mini-app/auth'
*/
auth.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: auth.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppAuthController::auth
* @see app/Http/Controllers/Api/V1/MiniAppAuthController.php:23
* @route '/api/v1/mini-app/auth'
*/
const authForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: auth.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppAuthController::auth
* @see app/Http/Controllers/Api/V1/MiniAppAuthController.php:23
* @route '/api/v1/mini-app/auth'
*/
authForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: auth.url(options),
    method: 'post',
})

auth.form = authForm

/**
* @see \App\Http\Controllers\Api\V1\MiniAppAuthController::contact
* @see app/Http/Controllers/Api/V1/MiniAppAuthController.php:34
* @route '/api/v1/mini-app/contact'
*/
export const contact = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: contact.url(options),
    method: 'get',
})

contact.definition = {
    methods: ["get","head"],
    url: '/api/v1/mini-app/contact',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\V1\MiniAppAuthController::contact
* @see app/Http/Controllers/Api/V1/MiniAppAuthController.php:34
* @route '/api/v1/mini-app/contact'
*/
contact.url = (options?: RouteQueryOptions) => {
    return contact.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\V1\MiniAppAuthController::contact
* @see app/Http/Controllers/Api/V1/MiniAppAuthController.php:34
* @route '/api/v1/mini-app/contact'
*/
contact.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: contact.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppAuthController::contact
* @see app/Http/Controllers/Api/V1/MiniAppAuthController.php:34
* @route '/api/v1/mini-app/contact'
*/
contact.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: contact.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppAuthController::contact
* @see app/Http/Controllers/Api/V1/MiniAppAuthController.php:34
* @route '/api/v1/mini-app/contact'
*/
const contactForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: contact.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppAuthController::contact
* @see app/Http/Controllers/Api/V1/MiniAppAuthController.php:34
* @route '/api/v1/mini-app/contact'
*/
contactForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: contact.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppAuthController::contact
* @see app/Http/Controllers/Api/V1/MiniAppAuthController.php:34
* @route '/api/v1/mini-app/contact'
*/
contactForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: contact.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

contact.form = contactForm

/**
* @see \App\Http\Controllers\Api\V1\MiniAppAuthController::claim
* @see app/Http/Controllers/Api/V1/MiniAppAuthController.php:44
* @route '/api/v1/mini-app/claim'
*/
export const claim = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: claim.url(options),
    method: 'post',
})

claim.definition = {
    methods: ["post"],
    url: '/api/v1/mini-app/claim',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\V1\MiniAppAuthController::claim
* @see app/Http/Controllers/Api/V1/MiniAppAuthController.php:44
* @route '/api/v1/mini-app/claim'
*/
claim.url = (options?: RouteQueryOptions) => {
    return claim.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\V1\MiniAppAuthController::claim
* @see app/Http/Controllers/Api/V1/MiniAppAuthController.php:44
* @route '/api/v1/mini-app/claim'
*/
claim.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: claim.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppAuthController::claim
* @see app/Http/Controllers/Api/V1/MiniAppAuthController.php:44
* @route '/api/v1/mini-app/claim'
*/
const claimForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: claim.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppAuthController::claim
* @see app/Http/Controllers/Api/V1/MiniAppAuthController.php:44
* @route '/api/v1/mini-app/claim'
*/
claimForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: claim.url(options),
    method: 'post',
})

claim.form = claimForm

/**
* @see \App\Http\Controllers\Api\V1\MiniAppAuthController::register
* @see app/Http/Controllers/Api/V1/MiniAppAuthController.php:49
* @route '/api/v1/mini-app/register'
*/
export const register = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: register.url(options),
    method: 'post',
})

register.definition = {
    methods: ["post"],
    url: '/api/v1/mini-app/register',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\V1\MiniAppAuthController::register
* @see app/Http/Controllers/Api/V1/MiniAppAuthController.php:49
* @route '/api/v1/mini-app/register'
*/
register.url = (options?: RouteQueryOptions) => {
    return register.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\V1\MiniAppAuthController::register
* @see app/Http/Controllers/Api/V1/MiniAppAuthController.php:49
* @route '/api/v1/mini-app/register'
*/
register.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: register.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppAuthController::register
* @see app/Http/Controllers/Api/V1/MiniAppAuthController.php:49
* @route '/api/v1/mini-app/register'
*/
const registerForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: register.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppAuthController::register
* @see app/Http/Controllers/Api/V1/MiniAppAuthController.php:49
* @route '/api/v1/mini-app/register'
*/
registerForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: register.url(options),
    method: 'post',
})

register.form = registerForm

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::bootstrap
* @see app/Http/Controllers/Api/V1/MiniAppController.php:20
* @route '/api/v1/mini-app/bootstrap'
*/
export const bootstrap = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: bootstrap.url(options),
    method: 'get',
})

bootstrap.definition = {
    methods: ["get","head"],
    url: '/api/v1/mini-app/bootstrap',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::bootstrap
* @see app/Http/Controllers/Api/V1/MiniAppController.php:20
* @route '/api/v1/mini-app/bootstrap'
*/
bootstrap.url = (options?: RouteQueryOptions) => {
    return bootstrap.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::bootstrap
* @see app/Http/Controllers/Api/V1/MiniAppController.php:20
* @route '/api/v1/mini-app/bootstrap'
*/
bootstrap.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: bootstrap.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::bootstrap
* @see app/Http/Controllers/Api/V1/MiniAppController.php:20
* @route '/api/v1/mini-app/bootstrap'
*/
bootstrap.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: bootstrap.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::bootstrap
* @see app/Http/Controllers/Api/V1/MiniAppController.php:20
* @route '/api/v1/mini-app/bootstrap'
*/
const bootstrapForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: bootstrap.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::bootstrap
* @see app/Http/Controllers/Api/V1/MiniAppController.php:20
* @route '/api/v1/mini-app/bootstrap'
*/
bootstrapForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: bootstrap.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::bootstrap
* @see app/Http/Controllers/Api/V1/MiniAppController.php:20
* @route '/api/v1/mini-app/bootstrap'
*/
bootstrapForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: bootstrap.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

bootstrap.form = bootstrapForm

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::referrals
* @see app/Http/Controllers/Api/V1/MiniAppController.php:28
* @route '/api/v1/mini-app/referrals'
*/
export const referrals = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: referrals.url(options),
    method: 'get',
})

referrals.definition = {
    methods: ["get","head"],
    url: '/api/v1/mini-app/referrals',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::referrals
* @see app/Http/Controllers/Api/V1/MiniAppController.php:28
* @route '/api/v1/mini-app/referrals'
*/
referrals.url = (options?: RouteQueryOptions) => {
    return referrals.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::referrals
* @see app/Http/Controllers/Api/V1/MiniAppController.php:28
* @route '/api/v1/mini-app/referrals'
*/
referrals.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: referrals.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::referrals
* @see app/Http/Controllers/Api/V1/MiniAppController.php:28
* @route '/api/v1/mini-app/referrals'
*/
referrals.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: referrals.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::referrals
* @see app/Http/Controllers/Api/V1/MiniAppController.php:28
* @route '/api/v1/mini-app/referrals'
*/
const referralsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: referrals.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::referrals
* @see app/Http/Controllers/Api/V1/MiniAppController.php:28
* @route '/api/v1/mini-app/referrals'
*/
referralsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: referrals.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::referrals
* @see app/Http/Controllers/Api/V1/MiniAppController.php:28
* @route '/api/v1/mini-app/referrals'
*/
referralsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: referrals.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

referrals.form = referralsForm

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::loyalty
* @see app/Http/Controllers/Api/V1/MiniAppController.php:78
* @route '/api/v1/mini-app/loyalty'
*/
export const loyalty = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: loyalty.url(options),
    method: 'get',
})

loyalty.definition = {
    methods: ["get","head"],
    url: '/api/v1/mini-app/loyalty',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::loyalty
* @see app/Http/Controllers/Api/V1/MiniAppController.php:78
* @route '/api/v1/mini-app/loyalty'
*/
loyalty.url = (options?: RouteQueryOptions) => {
    return loyalty.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::loyalty
* @see app/Http/Controllers/Api/V1/MiniAppController.php:78
* @route '/api/v1/mini-app/loyalty'
*/
loyalty.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: loyalty.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::loyalty
* @see app/Http/Controllers/Api/V1/MiniAppController.php:78
* @route '/api/v1/mini-app/loyalty'
*/
loyalty.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: loyalty.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::loyalty
* @see app/Http/Controllers/Api/V1/MiniAppController.php:78
* @route '/api/v1/mini-app/loyalty'
*/
const loyaltyForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: loyalty.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::loyalty
* @see app/Http/Controllers/Api/V1/MiniAppController.php:78
* @route '/api/v1/mini-app/loyalty'
*/
loyaltyForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: loyalty.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::loyalty
* @see app/Http/Controllers/Api/V1/MiniAppController.php:78
* @route '/api/v1/mini-app/loyalty'
*/
loyaltyForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: loyalty.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

loyalty.form = loyaltyForm

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::balanceHistory
* @see app/Http/Controllers/Api/V1/MiniAppController.php:52
* @route '/api/v1/mini-app/balance-history'
*/
export const balanceHistory = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: balanceHistory.url(options),
    method: 'get',
})

balanceHistory.definition = {
    methods: ["get","head"],
    url: '/api/v1/mini-app/balance-history',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::balanceHistory
* @see app/Http/Controllers/Api/V1/MiniAppController.php:52
* @route '/api/v1/mini-app/balance-history'
*/
balanceHistory.url = (options?: RouteQueryOptions) => {
    return balanceHistory.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::balanceHistory
* @see app/Http/Controllers/Api/V1/MiniAppController.php:52
* @route '/api/v1/mini-app/balance-history'
*/
balanceHistory.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: balanceHistory.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::balanceHistory
* @see app/Http/Controllers/Api/V1/MiniAppController.php:52
* @route '/api/v1/mini-app/balance-history'
*/
balanceHistory.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: balanceHistory.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::balanceHistory
* @see app/Http/Controllers/Api/V1/MiniAppController.php:52
* @route '/api/v1/mini-app/balance-history'
*/
const balanceHistoryForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: balanceHistory.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::balanceHistory
* @see app/Http/Controllers/Api/V1/MiniAppController.php:52
* @route '/api/v1/mini-app/balance-history'
*/
balanceHistoryForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: balanceHistory.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::balanceHistory
* @see app/Http/Controllers/Api/V1/MiniAppController.php:52
* @route '/api/v1/mini-app/balance-history'
*/
balanceHistoryForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: balanceHistory.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

balanceHistory.form = balanceHistoryForm

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::profile
* @see app/Http/Controllers/Api/V1/MiniAppController.php:117
* @route '/api/v1/mini-app/profile'
*/
export const profile = (options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: profile.url(options),
    method: 'patch',
})

profile.definition = {
    methods: ["patch"],
    url: '/api/v1/mini-app/profile',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::profile
* @see app/Http/Controllers/Api/V1/MiniAppController.php:117
* @route '/api/v1/mini-app/profile'
*/
profile.url = (options?: RouteQueryOptions) => {
    return profile.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::profile
* @see app/Http/Controllers/Api/V1/MiniAppController.php:117
* @route '/api/v1/mini-app/profile'
*/
profile.patch = (options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: profile.url(options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::profile
* @see app/Http/Controllers/Api/V1/MiniAppController.php:117
* @route '/api/v1/mini-app/profile'
*/
const profileForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: profile.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::profile
* @see app/Http/Controllers/Api/V1/MiniAppController.php:117
* @route '/api/v1/mini-app/profile'
*/
profileForm.patch = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: profile.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

profile.form = profileForm

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::join
* @see app/Http/Controllers/Api/V1/MiniAppController.php:92
* @route '/api/v1/mini-app/join'
*/
export const join = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: join.url(options),
    method: 'post',
})

join.definition = {
    methods: ["post"],
    url: '/api/v1/mini-app/join',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::join
* @see app/Http/Controllers/Api/V1/MiniAppController.php:92
* @route '/api/v1/mini-app/join'
*/
join.url = (options?: RouteQueryOptions) => {
    return join.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::join
* @see app/Http/Controllers/Api/V1/MiniAppController.php:92
* @route '/api/v1/mini-app/join'
*/
join.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: join.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::join
* @see app/Http/Controllers/Api/V1/MiniAppController.php:92
* @route '/api/v1/mini-app/join'
*/
const joinForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: join.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::join
* @see app/Http/Controllers/Api/V1/MiniAppController.php:92
* @route '/api/v1/mini-app/join'
*/
joinForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: join.url(options),
    method: 'post',
})

join.form = joinForm

const miniApp = {
    auth: Object.assign(auth, auth),
    contact: Object.assign(contact, contact),
    claim: Object.assign(claim, claim),
    register: Object.assign(register, register),
    bootstrap: Object.assign(bootstrap, bootstrap),
    referrals: Object.assign(referrals, referrals),
    loyalty: Object.assign(loyalty, loyalty),
    balanceHistory: Object.assign(balanceHistory, balanceHistory),
    profile: Object.assign(profile, profile),
    join: Object.assign(join, join),
    qr: Object.assign(qr, qr),
    session: Object.assign(session, session),
    avatar: Object.assign(avatar, avatar),
    onlineTopup: Object.assign(onlineTopup, onlineTopup),
}

export default miniApp